import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, catchError, finalize, firstValueFrom, map, Observable, of } from 'rxjs';
import { DialogCreaStakeholderComponent } from 'src/app/page/analisi-materialita/stakeholder/dialog/dialog-crea-stakeholder/dialog-crea-stakeholder.component';
import { AziendaService } from 'src/app/services/azienda/azienda.service';
import { MaterialitaService } from 'src/app/services/materialita/materialita.service';
import {
  CategoriaStakeholders,
  Categorie,
  Stakeholder,
  StakeholderService,
} from 'src/app/services/stakeholder/stakeholder.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogFiltroGenericoComponent } from '../../dialog-filtro-generico/dialog-filtro-generico.component';
import { Filters } from '../../lista-tabellare/classes/lista-tabellare-data-source';
import { SpinnerOverlayComponent } from '../../spinner-overlay/spinner-overlay.component';
import { DialogSceltaCampioneComponent } from './dialog-scelta-campione/dialog-scelta-campione.component';

type GetStakeholdersFn = (
  idMaterialita: string,
  tipo: 'INTERNI' | 'ESTERNI',
) => Observable<CategoriaStakeholders[]>;

type SalvaStakeholdersFn = (
  idMaterialita: string,
  tipo: 'INTERNI' | 'ESTERNI',
  categorieStakeholders: CategoriaStakeholders[],
) => Observable<any>;

@Component({
  selector: 'app-seleziona-stakeholders',
  templateUrl: './seleziona-stakeholders.component.html',
  styleUrls: ['./seleziona-stakeholders.component.scss'],
  standalone: false,
})
export class SelezionaStakeholdersComponent implements OnInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public isPermessoSoloRead: boolean =
    !this.utenteService.isPermessoAttivo('EDIT_STAKEHOLDERS') &&
    !this.utenteService.isPermessoAttivo('CREATE_STAKEHOLDERS');
  public arrayGroupCateStake: CategoriaStakeholders[] = [];
  private _filteredArrayGroupCateStake: CategoriaStakeholders[] = [];

  // public totPeso = 0;
  public nrSelezionati: number = 0; // ? usato nell'interfaccia per decidere le chack selezionate

  public searchValue: string = '';

  public btnSelezionaTutto = true;

  private readonly _totPeso = new BehaviorSubject<number>(0);
  public totPeso = this._totPeso.asObservable();

  public _categorie: Categorie[] = [];

  /**
   * Tipologia di stakeholder
   */
  private _tipo: 'INTERNI' | 'ESTERNI' = 'INTERNI';

  @Input()
  get tipo() {
    return this._tipo;
  }

  set tipo(_tipo: 'INTERNI' | 'ESTERNI') {
    this._tipo = _tipo;
  }

  private _mostraTutorial: boolean = true;

  @Input()
  get mostraTutorial() {
    return this._mostraTutorial;
  }

  set mostraTutorial(_mostraTutorial: boolean) {
    this._mostraTutorial = _mostraTutorial;
  }

  private _gestionePeso: boolean = false;

  @Input()
  get gestionePeso() {
    return this._gestionePeso;
  }

  set gestionePeso(_gestionePeso: boolean) {
    this._gestionePeso = _gestionePeso;
  }

  private _pesoPerStakeholder: boolean = false;

  @Input()
  get pesoPerStakeholder() {
    return this._pesoPerStakeholder;
  }

  set pesoPerStakeholder(_pesoPerStakeholder: boolean) {
    this._pesoPerStakeholder = _pesoPerStakeholder;
  }

  private _gestioneSceltaCampione: boolean = false;

  @Input()
  get gestioneSceltaCampione() {
    return this._gestioneSceltaCampione;
  }

  set gestioneSceltaCampione(_gestioneSceltaCampione: boolean) {
    this._gestioneSceltaCampione = _gestioneSceltaCampione;
  }

  private _getStakeholdersFn: GetStakeholdersFn | undefined;

  @Input()
  get getStakeholdersFn(): GetStakeholdersFn | undefined {
    return this._getStakeholdersFn;
  }

  set getStakeholdersFn(getStakeholdersFn: GetStakeholdersFn | undefined) {
    this._getStakeholdersFn = getStakeholdersFn;
  }

  private _salvaStakeholdersFn: SalvaStakeholdersFn | undefined;

  @Input()
  get salvaStakeholdersFn(): SalvaStakeholdersFn | undefined {
    return this._salvaStakeholdersFn;
  }

  set salvaStakeholdersFn(salvaStakeholdersFn: SalvaStakeholdersFn | undefined) {
    this._salvaStakeholdersFn = salvaStakeholdersFn;
  }

  private _idMaterialita: string | undefined;

  @Input()
  get idMaterialita(): string | undefined {
    return this._idMaterialita;
  }

  set idMaterialita(idMaterialita: string | undefined) {
    this._idMaterialita = idMaterialita;
    this._getStakeholders();
  }

  private _disabled = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(disabled: boolean) {
    this._disabled = !!disabled;
  }

  public _fatturato?: number;

  @Input()
  get fatturato(): number | undefined {
    return this._fatturato;
  }

  set fatturato(fatturato: number | undefined) {
    this._fatturato = fatturato;
  }

  public _nrDipendenti?: number;

  @Input()
  get nrDipendenti(): number | undefined {
    return this._nrDipendenti;
  }

  set nrDipendenti(nrDipendenti: number | undefined) {
    this._nrDipendenti = nrDipendenti;
  }

  /**
   * Volori del filtro valorizzati dalla dialog del filtro
   */
  private _valoriFiltro: Filters[] = [];

  @Input()
  get valFiltri(): Filters[] {
    return this._valoriFiltro;
  }

  /**
   * Filtri impostati da iterfaccia
   */
  private readonly _filtri: { [key: string]: any }[] = [
    {
      titolo: 'Nome',
      forControlName: 'nome',
      input: 'text',
    },
    {
      titolo: 'Cognome',
      forControlName: 'cognome',
      input: 'text',
    },

    {
      titolo: 'Email',
      forControlName: 'email',
      input: 'text',
    },
    {
      titolo: 'Categoria',
      forControlName: 'categoria',
      fnDatiOption: () => this._getCategorie(),
      idValueOption: 'id',
      descValueOption: 'titolo',
      input: 'multiple-option',
    },
  ];

  allComplete: { [key: string]: boolean } = {};

  constructor(
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private readonly utilityService: UtilityService,
    private readonly stakeholderService: StakeholderService,
    private readonly aziendaService: AziendaService,
    private readonly materialitaService: MaterialitaService,
    private readonly utenteService: UtenteService,
  ) {}

  ngOnInit(): void {
    this._subsCategorie();
  }

  private _subsCategorie() {
    this._getCategorie().subscribe({
      next: (result) => {
        this._categorie = result;
      },
      error: (err) => {
        console.error('Errore caricamento categorie : ', err);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Impossibile caricare le categorie',
          bottoni: [{ nome_btn: 'Ok' }],
        });
      },
    });
  }

  public applicaFiltroRicerca(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue;

    if (!this.searchValue || this.searchValue === '') {
      this.arrayGroupCateStake = this._filteredArrayGroupCateStake;
      return;
    }

    this.arrayGroupCateStake = this._filteredArrayGroupCateStake
      .map((item) => {
        let stake = item.stakeholders.filter(
          (st) =>
            st.cognome.toLowerCase().includes(this.searchValue?.toLowerCase() || '') ||
            st.nome.toLowerCase().includes(this.searchValue?.toLowerCase() || ''),
        );

        return {
          ...item,
          stakeholders: stake,
        };
      })
      .filter((cate) => cate.stakeholders.length);
  }

  public selezionaTutto() {
    this.btnSelezionaTutto = false;

    this.arrayGroupCateStake.forEach((cateStake) => {
      const filtCateStak = this._filteredArrayGroupCateStake.find((filt) => {
        return filt.id === cateStake.id;
      });

      cateStake.stakeholders.forEach((stake) => {
        stake.selected = true;
        if (!stake.pesoAssoluto) {
          stake.pesoAssoluto = 100;
        }

        let siltStake = filtCateStak?.stakeholders.find((findStake) => {
          return findStake.id === stake.id;
        });

        if (siltStake) {
          siltStake.selected = true;
          if (!siltStake.pesoAssoluto) {
            siltStake.pesoAssoluto = 100;
          }
        }
      });

      this.updateAllComplete(cateStake);
    });
  }

  public deselezionaTutto() {
    this.btnSelezionaTutto = true;

    this.arrayGroupCateStake.forEach((cateStake) => {
      const filtCateStak = this._filteredArrayGroupCateStake.find((filt) => {
        return filt.id === cateStake.id;
      });

      cateStake.stakeholders.forEach((stake) => {
        stake.selected = false;

        let siltStake = filtCateStak?.stakeholders.find((findStake) => {
          return findStake.id === stake.id;
        });

        if (siltStake) {
          siltStake.selected = false;
        }
      });

      this.updateAllComplete(cateStake);
    });
  }

  public apriFiltro() {
    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltro,
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '60%',
      maxHeight: '90%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltro = result.filtri;

        if (this._valoriFiltro) {
          const categoria = this._valoriFiltro.find((filt) => filt.chiave === 'categoria');

          this.arrayGroupCateStake = this._filteredArrayGroupCateStake
            .filter((cta) => {
              if (categoria) {
                return categoria.values.includes(cta.id);
              } else {
                return true;
              }
            })
            .map((item) => {
              const stFilt = item.stakeholders.filter((st) => {
                return this._valoriFiltro
                  .map((filtro) => {
                    return this._checkStakeholder(st, filtro);
                  })
                  .reduce((previous, check) => {
                    return previous && check;
                  }, true);
              });

              return { ...item, stakeholders: stFilt };
            });
        }
      }
    });
  }

  public addStake(catst: CategoriaStakeholders) {
    const cat = this._categorie.find((val) => val.id === catst.id);

    if (!cat) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Categoria non trovata',
        bottoni: [{ nome_btn: 'Ok' }],
      });
      return;
    }

    const st = {
      categoria: cat,
      tipologia: this._tipo,
    };

    const dialogCreaStakeholder = this.dialog.open(DialogCreaStakeholderComponent, {
      data: {
        stakeholder: st,
        isStakeHolderInMat: true,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      maxHeight: '90%',
      maxWidth: '80%',
      autoFocus: false,
    });

    dialogCreaStakeholder.afterClosed().subscribe((result) => {
      //** SALVO GLI STAKEHOLDER SELEZIONATI PER EVITARE DI PERDERE I VALORI DELLA MATERIALITA

      if (result && this.idMaterialita) {
        if (!this._salvaStakeholdersFn) {
          console.warn('FUNZIONE DI SALVATAGGIO STAKEHOLDERS NON IMPOSTATA');
          return;
        }

        //this.materialitaService.putMateStake(
        this._salvaStakeholdersFn(
          this.idMaterialita,
          this.tipo,
          this.getValoriSelezionati(),
        ).subscribe({
          next: (stakeholder) => {
            this._getStakeholders();
          },
          error: (err) => {
            console.error(err);
          },
        });
      }
    });
  }

  public modifica(st: any) {
    const dialogCreaStakeholder = this.dialog.open(DialogCreaStakeholderComponent, {
      data: {
        readOnly: this.disabled,
        stakeholder: st,
        isStakeHolderInMat: true,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      maxHeight: '90%',
      maxWidth: '80%',
      autoFocus: false,
    });

    dialogCreaStakeholder.afterClosed().subscribe((result) => {
      //** SALVO GLI STAKEHOLDER SELEZIONATI PER EVITARE DI PERDERE I VALORI DELLA MATERIALITA

      if (result && this.idMaterialita) {
        if (!this._salvaStakeholdersFn) {
          console.warn('FUNZIONE DI SALVATAGGIO STAKEHOLDERS NON IMPOSTATA');
          return;
        }

        // this.materialitaService.putMateStake(
        this._salvaStakeholdersFn(
          this.idMaterialita,
          this.tipo,
          this.getValoriSelezionati(),
        ).subscribe({
          next: (stakeholder) => {
            this._getStakeholders();
          },
          error: (err) => {
            console.error(err);
          },
        });
      }
    });
  }

  onKeyDown(event: KeyboardEvent): void {
    // Verifica se il tasto premuto è il carattere "-"
    if (event.key === '-') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  cambioPeso(event: InputEvent, catst: CategoriaStakeholders) {
    let valore = parseFloat((event.target as any).value);

    if (isNaN(valore) || valore < 0) {
      valore = 0;
    }

    catst.pesoAssoluto = valore;

    const categoriaNoFilter = this._filteredArrayGroupCateStake.find((cat) => cat.id === catst.id);

    if (categoriaNoFilter) {
      categoriaNoFilter.pesoAssoluto = catst.pesoAssoluto;
    }

    this._totPeso.next(
      this._filteredArrayGroupCateStake.reduce((prev: number, current: CategoriaStakeholders) => {
        return prev + (current.pesoAssoluto ?? 0);
      }, 0),
    );

    /*  this.ctrPeso(); */
  }

  public cambioPesoStakeholder(
    event: InputEvent,
    cat: CategoriaStakeholders,
    stakeholder: Stakeholder,
  ) {
    let valore = parseFloat((event.target as any).value);

    if (isNaN(valore) || valore < 0) {
      valore = 0;
    }

    stakeholder.pesoAssoluto = valore;
    (event.target as any).value = valore;

    const categoriaNoFilter = this._filteredArrayGroupCateStake.find(
      (categ) => categ.id === cat.id,
    );

    if (categoriaNoFilter) {
      const staTrovato = categoriaNoFilter.stakeholders.find(
        (stake) => stake.id === stakeholder.id,
      );

      if (staTrovato) {
        staTrovato.pesoAssoluto = stakeholder.pesoAssoluto;
      }
    }
  }

  public updateAllComplete(catst: CategoriaStakeholders) {
    setTimeout(() => {
      this.allComplete[catst.id] =
        catst.stakeholders?.length > 0 && catst.stakeholders.every((t) => t.selected);
    }, 0);
  }

  public someComplete(catst: CategoriaStakeholders): boolean {
    if (!catst.stakeholders) {
      return false;
    }
    //** controllare la dichiarazione prima di cambiare
    this.nrSelezionati = catst.stakeholders.filter((t) => t.selected).length;
    return !!this.nrSelezionati && this.nrSelezionati != catst.stakeholders.length;
  }

  public setAll(selected: boolean, catst: CategoriaStakeholders) {
    if (catst.stakeholders == null) {
      return;
    }
    catst.stakeholders.forEach((t) => {
      t.selected = selected;
      if (selected && !t.pesoAssoluto && this.pesoPerStakeholder) {
        t.pesoAssoluto = 100;
      }
    });
    this.updateAllComplete(catst);
  }

  public onStakeholderToggle(
    catst: CategoriaStakeholders,
    stakeholder: Stakeholder,
    isChecked: boolean,
  ) {
    if (isChecked && !stakeholder.pesoAssoluto && this.pesoPerStakeholder) {
      stakeholder.pesoAssoluto = 100;
    }
    this.updateAllComplete(catst);
  }

  //** CHIAMATO DALL'ESTERNO
  public getValoriSelezionati() {
    return this.stakeholderService.getValoriSelezionati(this.arrayGroupCateStake);
  }

  public async refreshStakeholders(): Promise<boolean> {
    this._subsCategorie();
    const result = await this._getStakeholders();
    if (result) {
      return true;
    }
    return false;
  }

  public comeDefinireIlPeso() {
    this.utilityService.openDialog({
      fontWeight: 'normal',
      descrizione:
        'Il peso degli stakeholder viene definito in base a diversi fattori, quali: <br>' +
        '<ul>' +
        ' <li>Influenza sugli obiettivi aziendali </li> ' +
        " <li>Importanza per l'azienda rispetto alla sostenibilità </li> " +
        ' <li>Impatti reciproci tra stakeholder e azienda </li> ' +
        ' <li>Coinvolgimento storico e livello di relazione con lo stakeholder </li> ' +
        ' <li>Settore e contesto operativo (geografico, normativo o sociale) </li> ' +
        ' <li>Esistenza di vincoli e aspettative normative che attribuiscono rilevanza a determinati stakeholder </li>' +
        '</ul>',
      bottoni: [
        {
          nome_btn: 'OK',
        },
      ],
    });
  }

  public modificaSceltaCampione(cat: CategoriaStakeholders) {
    if (!this.idMaterialita) {
      console.warn('ID MATERIALITA NON TROVATO, IMPOSSIBILE PROSEGUIRE');
      return;
    }

    if (!this._salvaStakeholdersFn) {
      console.warn('FUNZIONE DI SALVATAGGIO STAKEHOLDERS NON IMPOSTATA');
      return;
    }

    this.spinnerOver.show();

    this._salvaStakeholdersFn(this.idMaterialita, this.tipo, this.getValoriSelezionati())
      .pipe(
        finalize(() => {
          this.spinnerOver.hide();
        }),
      )
      .subscribe({
        next: (stakeholder) => {
          const dialogCreaStakeholder = this.dialog.open(DialogSceltaCampioneComponent, {
            data: {
              idMaterialita: this.idMaterialita,
              tipologia: this.tipo,
              idCategoria: cat.id,

              sceltaCampione: cat.sceltaCampione,
              obbligatorio: this.aziendaService.isSogliaSuperata(this.fatturato, this.nrDipendenti),
            },
            panelClass: ['dialog-container'],
            disableClose: false,
            width: '70%',
            maxHeight: '90%',
            maxWidth: '80%',
            autoFocus: false,
          });

          dialogCreaStakeholder.afterClosed().subscribe((esito) => {
            if (esito.salva) {
              cat.sceltaCampione = esito.sceltaCampione || '';
            }
          });
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Sviluppo fermo per feedback. Se ci saranno da implementare controlli allora da azioinare su questo metodo che
   * viene chiamato solamente dentro la DM. Altrimenti si può cancellare direttamente il metodo e i suoi sotto controlli
   * @returns
   */
  public checkValidita() {
    return (
      !this.gestionePeso ||
      (this.ctrPeso() &&
        (!this.pesoPerStakeholder || this._ctrPesoAllCat()) &&
        (!this.gestioneSceltaCampione || this._ctrSceltaCampione()))
    );
  }

  /**
   * Controllo peso sulle categorie e sugli stakeholders
   * deve essere maggiore di 0 se selezionato
   * @returns
   */
  public ctrPeso(): boolean {
    for (const cat of this.arrayGroupCateStake) {
      // Controllo se ci sono stakeholder selezionati
      const hasSelected = cat.stakeholders.some((sh) => sh.selected);
      if (hasSelected) {
        if (!cat.pesoAssoluto || cat.pesoAssoluto <= 0) {
          this.utilityService.openSnackBar(
            `Il peso della categoria "${cat.titolo}" deve essere maggiore di 0`,
            '',
            { duration: 4000, panelClass: ['red-snackbar'] },
          );
          return false;
        }

        if (this.pesoPerStakeholder && this.gestionePeso) {
          for (const sh of cat.stakeholders) {
            if (sh.selected && (!sh.pesoAssoluto || sh.pesoAssoluto <= 0)) {
              this.utilityService.openSnackBar(
                `Il peso dello Stakeholder ${sh.cognome} ${sh.nome} deve essere maggiore di 0`,
                '',
                { duration: 4000, panelClass: ['red-snackbar'] },
              );
              return false;
            }
          }
        }
      }
    }

    return true;
  }

  private _checkStakeholder(stakeholder: Stakeholder, filtro: Filters) {
    const valStake = stakeholder[filtro.chiave as keyof Stakeholder];
    switch (filtro.operator) {
      case 'lk': {
        const like = filtro.values.find((val) => {
          if (typeof valStake === 'string') {
            return valStake.indexOf(val) >= 0;
          } else {
            return valStake === val;
          }
        });
        return !!like;
      }
      case 'eq':
        if (typeof valStake === 'object') {
          return filtro.values.includes((valStake as Categorie).id);
        } else {
          return filtro.values.includes(valStake);
        }
      default:
        return false;
    }
  }

  private async _getStakeholders(): Promise<boolean> {
    if (this.idMaterialita && this._getStakeholdersFn) {
      return firstValueFrom(
        this._getStakeholdersFn(this.idMaterialita, this.tipo).pipe(
          map((stakeMat) => {
            this.arrayGroupCateStake = stakeMat;

            this._filteredArrayGroupCateStake = stakeMat;

            this.arrayGroupCateStake.forEach((cat) => this.updateAllComplete(cat));

            if (
              this.arrayGroupCateStake.filter((val) => val.stakeholders?.length > 0).length === 1
            ) {
              if (!this.arrayGroupCateStake[0].pesoAssoluto) {
                this.arrayGroupCateStake[0].pesoAssoluto = 100;
              }
              this.allComplete[this.arrayGroupCateStake[0].id] = true;
              this.setAll(true, this.arrayGroupCateStake[0]);
            }

            this._totPeso.next(this._getTooPeso());
            return true;
          }),
          catchError((err) => {
            console.error(err);
            return of(false);
          }),
        ),
      );
    }
    return false;
  }

  private _getTooPeso() {
    return this._filteredArrayGroupCateStake.reduce(
      (prev: number, current: CategoriaStakeholders) => {
        return prev + (current.pesoAssoluto ?? 0);
      },
      0,
    );
  }

  private _getCategorie() {
    return this.stakeholderService
      .getCategorieStake(0, 1000, '', [
        {
          chiave: 'tipologia',
          operator: 'eq',
          values: [this.tipo],
        },
      ])
      .pipe(map((value) => value?.content || []));
  }

  private _ctrPesoAllCat() {
    /*  for (const cat of this.getValoriSelezionati()) {
      if (!this._ctrPesoCat(cat)) {
        return false;
      }
    } */

    return true;
  }

  /*   private _ctrPesoCat(cat: CategoriaStakeholders): boolean {
    const tot = cat.stakeholders.reduce((prev: number, current: Stakeholder) => {
      return prev + (current.peso ?? 0);
    }, 0);

    if (tot != 100) {
      let msg =
        'Il peso totale degli stakeholders per la categoria "' +
        cat.titolo +
        '"non può essere minore di 100';

      if (tot > 100) {
        msg =
          'Il peso totale degli stakeholders per la categoria "' +
          cat.titolo +
          '"non può essere maggiore di 100';
      }

      this.utilityService.openSnackBar(msg, '', {
        duration: 4000,
        panelClass: ['red-snackbar'],
      });
      return false;
    }
    return true;
  } */

  private _ctrSceltaCampione() {
    if (this.aziendaService.isSogliaSuperata(this.fatturato, this.nrDipendenti)) {
      // Obbligatorio, tutte le categorie selezionate devono avere la scelta del campione

      // Se il trigger è superato il testo della scelta del campione è obbligatorio.
      for (const cat of this.getValoriSelezionati()) {
        if (!cat.sceltaCampione) {
          this.utilityService.openSnackBar(
            'Inserire la motivazione della scelta del campione sulla categoria "' +
              cat.titolo +
              '".',
            '',
            {
              duration: 4000,
              panelClass: ['red-snackbar'],
            },
          );
          return false;
        }
      }
    }

    return true;
  }

  /**
   * Calcola il peso totale degli stakeholder selezionati.
   *
   * @param listaSh Lista di stakeholder.
   * @returns Somma dei pesi degli stakeholder che risultano selezionati.
   */
  public getTotalePesoSh(listaSh: Stakeholder[]): number {
    return listaSh.reduce((acc, sh) => acc + (sh.selected ? (sh.pesoAssoluto ?? 0) : 0), 0);
  }

  /**
   * Calcola il peso totale delle categorie completate.
   *
   * Una categoria contribuisce al totale se risulta parzialmente o totalmente completata.
   *
   * @returns Somma dei pesi delle categorie completate.
   */
  public getTotalePesoCategorie(): number {
    return this.arrayGroupCateStake.reduce(
      (acc, cat) =>
        acc + (this.someComplete(cat) || this.allComplete[cat.id] ? (cat.pesoAssoluto ?? 0) : 0),
      0,
    );
  }

  /**
   * Converte un valore assoluto in percentuale rispetto al totale.
   *
   * @param valore Valore assoluto da convertire in percentuale.
   * @param totalePeso Totale rispetto al quale calcolare la percentuale.
   * @returns Percentuale del valore rispetto al totale, con due decimali.
   *          Ritorna `0` se il totale è `0` o se il calcolo non è valido.
   */
  public calcolaPercentualeDaAssoluto(
    valore: number | undefined,
    totalePeso: number,
    listaCatOrSh: any,
  ): number {
    const percent = parseFloat((((valore ?? 0) * 100) / totalePeso).toFixed(2));

    listaCatOrSh.peso = percent;

    return isNaN(percent) ? 0 : percent;
  }
}
